import { render } from "./App.vue?vue&type=template&id=f5248c04&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=f5248c04&scoped=true&lang=css"

import exportComponent from "/Users/curt/www/tsm-mobile-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5248c04"]])

export default __exports__